module.exports = "https://cdn.littlereply.com/tt/resource/tab5_icon_contact.8c60f2569754cb0e364867686ac27068.png";